<template>
    <div class="mt-0" :style="isMobile ? 'padding: 0px 15px' : ''">
        <ion-row class="ion-justify-content-center" data-cy="delivery-unavailable">
            <ion-col size="12">
                <h4 class="my-0 pb-4 color-black bold">Delivery Unavailable</h4>
                <h5 class="my-8">We currently cannot deliver to:</h5>
                <addressDisplay :address="deliveryAddress" data-cy="delivery-address" dense showZip />
                <h5 class="ion-text-center" style="padding: 15px 0px">Try another address or order pickup</h5>
                <ion-button expand="block" color="primary" @click="$emit('changePickup')">Order Pickup</ion-button>
            </ion-col>
        </ion-row>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IonRow, IonCol, IonButton } from '@ionic/vue';
import addressDisplay from '@/components/addressDisplay.vue';
import { Address } from '@/models/addressModels';

export default defineComponent({
    props: {
        deliveryAddress: {
            type: Object as PropType<Address>,
        },
        errorMsg: String,
        isMobile: Boolean,
    },
    components: { IonRow, IonCol, addressDisplay, IonButton },
    emits: ['changePickup'],
});
</script>
